import { GlobalPreferences } from '../../entities/user-preferences-v2/global-preferences';
import { DeviceWithAssetAndRadioData } from '../../entities/device-radios-v2/device-with-asset-and-radio-data-response';
import { RadioComponent } from '../../entities/device-radios-v2/common-device-or-radio-data';
import { AssetsResponse } from '../../entities/assets-v2';

export interface Result {
  equipmentType: string;
  moduleType: string | null;
  moduleId: string | null;
  deviceId: string | null;
  deviceKey: string | null;
  deviceType: string | null;
  commercialType: string | null;
  telematicsAssetId: string;
  assetSerialNumber: string;
  assetMake: string;
  radioComponents: RadioComponent[];
  deviceSerialNumber: string | null;
  isTethered: boolean;
  communicationMethod: string | null;
  response: DeviceWithAssetAndRadioData | AssetsResponse;
  dealer?: boolean;
  dealerCode?: string;
  deviceStatus: string | null;
  orbcommType: number | null;
  isTetheredToDeviceKey: string | null;
  deviceCharacterization: string | null;
  gpsRolloverStatus: string | null;
  createdTime: string | null;
  onboardApplicationMessageVersion: string | null;
}

export enum searchActionNames {
  SET_RECENT_SEARCHES = 'SET_RECENT_SEARCHES',
  ADD_RECENT_SEARCH_TEXT = 'ADD_RECENT_SEARCH_TEXT',
  ADD_RESULT = 'ADD_RESULT',
  CLEAR_RESULT = 'CLEAR_RESULT',
  CLEAR_RECENT_SEARCH_TEXT = 'CLEAR_RECENT_SEARCH_TEXT',
  SET_GLOBAL_PREFERENCES = 'SET_GLOBAL_PREFERENCES',
  SET_SELECTED_ENTITY = 'SET_SELECTED_ENTITY',
  SET_OTASP_STATUS = 'SET_OTASP_STATUS',
  SET_HAS_ERROR_FLAG = 'SET_HAS_ERROR_FLAG',
  SET_UPDATE_RECENT_FLAG = 'SET_UPDATE_RECENT_FLAG',
  SET_DEVICE_INFO_ERROR = 'SET_DEVICE_INFO_ERROR',
  SET_DEVICE_FORBIDDEN_ERROR = 'SET_DEVICE_FORBIDDEN_ERROR',
  SET_INTERNAL_SERVER_ERROR= 'SET_INTERNAL_SERVER_ERROR',
  SET_GATEWAY_TIMEOUT_ERROR= 'SET_GATEWAY_TIMEOUT_ERROR',
  SET_SELECTED_VIMS_ENTITY = 'SET_SELECTED_VIMS_ENTITY',
  SET_ECM_DATA = 'SET_ECM_DATA' ,
  SET_DEVICE_NOT_FOUND_ERROR='SET_DEVICE_NOT_FOUND_ERROR',
  SET_TELEMATICS_ID_ERROR= 'SET_TELEMATICS_ID_ERROR',
  SET_NETWORK_FAILURE_ERROR= 'SET_NETWORK_FAILURE_ERROR',
}

export interface SearchState {
  recent: { value: string; timeStamp: number, isFavourite: boolean }[];
  result: Result[] | [];
  selectedEntity: Result | undefined;
  otaspStatus: string | undefined;
  hasError: boolean;
  updateRecent: boolean;
  deviceInfoError: boolean;
  deviceForbiddenError: boolean;
  gatewayTimeoutError:boolean;
  networkFailureError:boolean;
  deviceNotFoundError:boolean;
  internalServerError:boolean;
  telematicsIdError:boolean;
  selectedVIMSEntity: Result | undefined;
  ecmData: []; 
}

interface SetRecentSearches {
  type: typeof searchActionNames.SET_RECENT_SEARCHES;
  payload: Array<{ value: string; timeStamp: number; isFavourite: boolean }>;
}

interface SetOtaspStatus {
  type: typeof searchActionNames.SET_OTASP_STATUS;
  payload: string;
}

interface AddSearchTextAction {
  type: typeof searchActionNames.ADD_RECENT_SEARCH_TEXT;
  payload: { value: string; timeStamp: number; isFavourite: boolean };
}

interface ClearSearchTextAction {
  type: typeof searchActionNames.CLEAR_RECENT_SEARCH_TEXT;
}

interface AddSearchResultAction {
  type: typeof searchActionNames.ADD_RESULT;
  payload: Result;
}

interface ClearSearchResultAction {
  type: typeof searchActionNames.CLEAR_RESULT;
}

interface SetGlobalPreferences {
  type: typeof searchActionNames.SET_GLOBAL_PREFERENCES;
  payload: GlobalPreferences;
}

interface SetSelectedEntity {
  type: typeof searchActionNames.SET_SELECTED_ENTITY;
  payload: Result;
}

interface SetHasErrorFlag {
  type: typeof searchActionNames.SET_HAS_ERROR_FLAG;
  payload: boolean;
}

interface SetTelematicsIdError {
  type: typeof searchActionNames.SET_TELEMATICS_ID_ERROR;
  payload: boolean;
}

interface SetUpdateRecentFlag {
  type: typeof searchActionNames.SET_UPDATE_RECENT_FLAG;
  payload: boolean;
}

interface SetDeviceInfoError {
  type: typeof searchActionNames.SET_DEVICE_INFO_ERROR;
  payload: boolean;
}

interface SetDeviceForbiddenError {
  type: typeof searchActionNames.SET_DEVICE_FORBIDDEN_ERROR;
  payload: boolean;
}

interface SetInternalServerError {
  type: typeof searchActionNames.SET_INTERNAL_SERVER_ERROR;
  payload: boolean;
}

interface SetGatewayTimeoutError {
  type: typeof searchActionNames.SET_GATEWAY_TIMEOUT_ERROR;
  payload: boolean;
}

interface SetNetworkFailureError {
  type: typeof searchActionNames.SET_NETWORK_FAILURE_ERROR;
  payload: boolean;
}

interface SetDeviceNotFoundError {
  type: typeof searchActionNames.SET_DEVICE_NOT_FOUND_ERROR;
  payload: boolean;
}
interface SetVIMSSelectedEntity {
  type: typeof searchActionNames.SET_SELECTED_VIMS_ENTITY;
  payload: Result;
}

interface SetECMData {
  type: typeof searchActionNames.SET_ECM_DATA;
  payload: [];
}


export type SearchActionTypes =
  | ClearSearchTextAction
  | AddSearchTextAction
  | AddSearchResultAction
  | ClearSearchResultAction
  | SetRecentSearches
  | SetGlobalPreferences
  | SetSelectedEntity
  | SetHasErrorFlag
  | SetUpdateRecentFlag
  | SetDeviceInfoError
  | SetDeviceForbiddenError
  | SetInternalServerError
  | SetGatewayTimeoutError
  | SetNetworkFailureError
  | SetOtaspStatus
  | SetVIMSSelectedEntity
  | SetDeviceNotFoundError
  | SetTelematicsIdError
  | SetECMData;
